import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AdminLeftMenu from "./AdminLeftMenu";
import { useTranslation } from "react-i18next";
import AdminCheck from "./AdminCheck";
import { db, getDocs, collection } from "../../firebase";
import GrowingChart1 from "./GrowingChart1";

const AdminStat = () => {
  const [ipdb, setIpdb] = useState([]);
  const { t, i18n } = useTranslation();
  const [usVisitor, setUsVisitor] = useState(0);
  const [usEachState, setusEachState] = useState({});
  const [koVisitor, setKoVisitor] = useState(0);
  const [koEachState, setkoEachState] = useState({});

  useEffect(() => {
    const getIPDB = async () => {
      setUsVisitor(0);
      setusEachState({});
      setKoVisitor(0);
      setkoEachState({});
      console.log("ACESSS DB");
      const querySnapshot = await getDocs(collection(db, "ipAddressTrack"));
      querySnapshot.forEach((doc) => {
        console.log(doc.id, " => ", doc.data());

        if (doc.data().countryCode === "US") {
          setUsVisitor((old) => +old + +doc.data().visits);

          let temp = usEachState;
          if (temp[doc.data().region]) {
            console.log("temp[doc.data().region]", temp[doc.data().region]);
            temp[doc.data().region] =
              temp[doc.data().region] + +doc.data().visits;
          } else {
            temp[doc.data().region] = doc.data().visits;
          }
          setusEachState(temp);
        }

        if (doc.data().countryCode === "KR") {
          setKoVisitor((old) => +old + +doc.data().visits);

          let temp = koEachState;
          if (temp[doc.data().region]) {
            console.log("temp[doc.data().region]", temp[doc.data().region]);
            temp[doc.data().region] =
              temp[doc.data().region] + +doc.data().visits;
          } else {
            temp[doc.data().region] = doc.data().visits;
          }
          setkoEachState(temp);
        }

        setIpdb((old) => [...old, { id: doc.id, ...doc.data() }]);
      });
    };
    getIPDB();
    return () => {
      setUsVisitor(null);
      setKoVisitor(null);
      setusEachState(null);
      setkoEachState(null);
    };
  }, []);

  console.log("usEachState", usEachState);
  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%", pb: 10 }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "22px" }}>E-Commerce Statistics </Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  View Details Stats
                </Box> */}
              </Box>

              <Grid container spacing={2}>
                <Grid item md={12} sm={12} xs={12}>
                  <Box sx={{ pt: 2 }}>
                    <GrowingChart1 />
                  </Box>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      backgroundColor: "white",
                      minHeight: "500px",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "15px",
                      }}
                    >
                      <Box>{t("Graphs")} </Box>
                    </Box>
                    <Box sx={{ px: 4, py: 3 }}>
                      여기서 보여시는 방문 횟수는 방문자가 브라우저 창을 열때
                      한번 방문한 것으로 집계됩니다.
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        px: 4,
                        py: 3,
                        borderTop: "1px solid lightgray",
                        pt: 2,
                      }}
                    >
                      <Box>
                        ※ 미국 사용자 방문 횟수: {usVisitor}번
                        <Box sx={{ pt: 2 }}>※ 주(State)당 방문자 집계</Box>
                        {Object.entries(usEachState).map(([key, value]) => {
                          return (
                            <Box sx={{ pl: "8px", pt: "3px" }}>
                              <span style={{ color: "gray", fontWeight: 600 }}>
                                {key}
                              </span>{" "}
                              : {value.toString()}
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        px: 4,
                        py: 3,
                        borderTop: "1px solid lightgray",
                        pt: 2,
                      }}
                    >
                      ※ 한국 사용자 방문 횟수: {koVisitor}번
                      <br />
                      <Box sx={{ pt: 2 }}>※ 한국 지역별 방문자 집계</Box>
                      {Object.entries(koEachState).map(([key, value]) => {
                        return (
                          <Box sx={{ pl: "8px", pt: "3px" }}>
                            <span style={{ color: "gray", fontWeight: 600 }}>
                              {key}
                            </span>{" "}
                            : {value.toString()}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminStat;
// users
